const autoNgTemplateLoaderTemplate1 = require('./kubernetesConfigurationData.html');

angular.module('shbdeployer.kubernetes').component('kubernetesConfigurationData', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesConfigurationDataController',
  bindings: {
    formValues: '=',
    isValid: '=',
    isCreation: '=',
    isEditorDirty: '=',
  },
});
